export default __webpack_public_path__ + "static/media/icicprodential.69bf4d43.png";